import firebase from 'firebase/app';
import 'firebase/storage';

// Initialize Firebase
var config = {
    apiKey: "AIzaSyCYda_knnZJEHzJESTpXIx4wlR0MPDnmQ8",
    authDomain: "asyncentric-tech.firebaseapp.com",
    databaseURL: "https://asyncentric-tech.firebaseio.com",
    projectId: "asyncentric-tech",
    storageBucket: "asyncentric-tech.appspot.com",
    messagingSenderId: "714660495035"
};
firebase.initializeApp(config);

const storage = firebase.storage();

export {
    firebase as default,
    storage
}